var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { TextField as TextFieldMUI } from '@material-ui/core';
import { FormFieldsContext } from '../MyForm';
export var MyFormikField = function (_a) {
    var _b;
    var name = _a.name, textFieldProps = __rest(_a, ["name"]);
    var form = React.useContext(FormFieldsContext);
    var handleChange = React.useCallback(function (e) {
        var _a;
        var value = (_a = e.target.value) !== null && _a !== void 0 ? _a : '';
        form.setFieldValue(name, value);
    }, [form, name]);
    var errorMessage = (_b = form === null || form === void 0 ? void 0 : form.errors) === null || _b === void 0 ? void 0 : _b[name];
    return (_jsx(TextFieldMUI, __assign({ size: "small", margin: "normal", variant: "outlined", type: "text", fullWidth: true }, textFieldProps, { onChange: handleChange, error: !!errorMessage, helperText: errorMessage ? errorMessage : textFieldProps.helperText }), void 0));
};
